<template>
    <ValidationErrors :show="showErrors"/>
    <Head :title="quote.name + ' - ' + fixture.title"/>
    <Audit v-if="openModal" @close="openModal = false" :open="openModal" :activity_logs="activity_logs" />
    <div class="w-full mb-6">
        <ValidationErrors/>
        <FixtureHeader :fixture="fixture">
            <template v-slot:info>
                <p v-if="quote.buy_currency_id !== quote.sell_currency_id"><strong>Buy/Sell Currency:</strong> {{ quote.buy_currency.code }}/{{quote.sell_currency.code}} @ {{quote.exchange_rate }}</p>
            </template>
            <template v-slot:actions>
                <Link :href="route('frontend.fixture.quote.index', fixture.id)"
                      class="inline-flex items-center h-10 px-4 py-2 border border-transparent rounded-md font-semibold text-xs uppercase text-black bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                    <ArrowCircleLeftIcon class="-ml-0.5 mr-2 h-4 w-4"></ArrowCircleLeftIcon>
                    Back to Quotes
                </Link>
            </template>
        </FixtureHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div class="pb-5 border-b border-gray-200 flex justify-between items-center">
                                <div class="flex grid grid-cols-2 items-center">
                                    <div>
                                        <div class="flex items-end">
                                            <h3
                                                class="flex text-lg leading-6 font-bold text-gray-900 mr-3">
                                                {{ quote.name }}
                                            </h3>
                                            <span class="text-sm font-medium">{{ quote.client.name }}</span>

                                            <div class="ml-3 flex-col">
                                                <span v-if="quote.status === 'Confirmed' || original === true"
                                                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-green-800">
                                                      Confirmed
                                                </span>
                                                <span v-else-if="quote.status === 'Not Sent'"
                                                      class="w-auto inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                                                        quote.status
                                                    }} </span>
                                                <span v-else-if="quote.status === 'Sent to Client'"
                                                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-yellow-800"> {{
                                                        quote.status
                                                    }} </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="flex items-end">
                                    <Button @click="emitter.emit('createFolderSlideout', {folder_id: null})"
                                            v-if="original === false"
                                            class="shadow-md inline-flex mr-3 items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                                        <folder-add-icon class="-ml-0.5 mr-2 h-4 w-4"></folder-add-icon>
                                        Add Folder
                                    </Button>
                                    <Button @click="emitter.emit('createServiceSlideout', null)"
                                            v-if="original === false"
                                            :class="{'mr-3': quote.status !== 'Confirmed'}"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24"
                                             stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                        Add Service Line
                                    </Button>
                                    <Button @click="confirmQuote(quote.id)"
                                            v-if="quote.status !== 'Confirmed' && original === false"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                                        <check-circle-icon class="-ml-0.5 mr-2 h-4 w-4"></check-circle-icon>
                                        Confirm
                                    </Button>
                                </div>
                            </div>
                            <AlertInfo v-if="bill_back_anomaly" :type="'warning'" :message="'Warning: Some service lines within this quote have different BIll Back options.'" />
                            <QuoteTabs/>
                            <div class="-my-2 !mt-0 offer-overflow-x-auto  sm:-mx-6 lg:-mx-8">
                                <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8 mw-1600">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <div
                                            class="bg-white shadow overflow-auto sm:rounded-md min-w-full table-example">
                                            <div class="w-full grid grid-cols-15 bg-gray-50">
                                                <div
                                                    class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Item
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Start Date
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    End Date
                                                </div>
                                                <div
                                                    class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Supplier
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Net Sell
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Gross Sell
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Net Buy
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Gross Buy
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Mgmt Fee
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Commission
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Markup
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r">
                                                    Profit
                                                </div>
                                                <div
                                                    class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                    Profit %
                                                </div>
                                            </div>
                                            <NestedDraggable type="folder" :class="'dragArea'" :items="items.folders" :invoice_quote_service_ids_not_paid="invoice_quote_service_ids_not_paid" :invoice_quote_service_ids_paid="invoice_quote_service_ids_paid"
                                                             :quote="quote"/>
                                            <NestedDraggable type="service" :items="items.services" :quote="quote" :invoice_quote_service_ids_not_paid="invoice_quote_service_ids_not_paid" :invoice_quote_service_ids_paid="invoice_quote_service_ids_paid"/>
                                            <div
                                                class="bg-white shadow overflow-hidden sm:rounded-md min-w-full table-example border-t border-t-2">
                                                <div class="w-full grid grid-cols-15 bg-gray-200">
                                                    <div
                                                        class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        Total
                                                    </div>
                                                    <div
                                                        class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="col-span-2 px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.net_sell_total, quote.sell_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.gross_sell_total, quote.sell_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.net_buy_total, quote.buy_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.gross_buy_total, quote.buy_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.management_fees_gross ?? subtotals.management_fees, quote.sell_currency.code, true)
                                                        }}
                                                    </div>

                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.commission, quote.buy_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.markup, quote.sell_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider border-r border-r-gray-300">
                                                        {{
                                                            formatCurrency(subtotals.profit, quote.sell_currency.code, true)
                                                        }}
                                                    </div>
                                                    <div
                                                        class="px-3 py-4 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        {{
                                                            number_format(parseFloat(subtotals.profit_percentage).toFixed(2))
                                                        }}%
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex gap-3 text-xs">
                                <span class="font-bold">Quote Options:</span>
                                <span @click="emitter.emit('createFolderSlideout', {folder_id: null})" v-if="original === false"
                                      class="flex hover:underline cursor-pointer"><FolderAddIcon
                                    class="w-4 h-4 mr-2"/> Add New Folder</span>
                                <span @click="emitter.emit('createServiceSlideout', null)" v-if="original === false"
                                      class="flex hover:underline cursor-pointer"><DocumentAddIcon
                                    class="w-4 h-4 mr-2"/> Add New Service</span>
                                <span @click="editQuote(quote)" class="flex hover:underline cursor-pointer" v-if="original === false"><PencilIcon
                                    class="w-4 h-4 mr-2 text-yellow-500"/> Rename Quote</span>
                                <a :href="route('frontend.fixture.quote.export.internal', [fixture.id, quote.id])"
                                   class="flex hover:underline cursor-pointer">
                                    <DocumentDownloadIcon
                                        class="w-4 h-4 mr-2 text-light-pitch-purple"/>
                                    Export Quote - Internal</a>
                                <a :href="route('frontend.fixture.quote.export.external', [fixture.id, quote.id])" v-if="quote.status !== 'Suppressed'"
                                   class="flex hover:underline cursor-pointer">
                                    <DocumentDownloadIcon
                                        class="w-4 h-4 mr-2 text-green-500"/>
                                    Export Quote - Client Version</a>
                                <span @click="emitter.emit('openImportAmazeQuote')" v-if="original === false"
                                   class="flex hover:underline cursor-pointer">
                                    <UploadIcon
                                        class="w-4 h-4 mr-2 text-yellow-500"/>
                                    Import Amaze Offer into Quote</span>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
        <CreateFolder :quote="quote" :fixture="fixture"/>
        <CreateQuote ref="create_quote" :fixture="fixture"/>
        <CreateService :quote="quote" :fixture="fixture"/>
        <ImportAmazeQuote :quote="quote" :fixture="fixture"/>
    </div>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated";
import {Link, Head, usePage, useForm} from "@inertiajs/vue3";
import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    CheckCircleIcon,
    ArrowCircleLeftIcon,
    FolderAddIcon,
    FolderIcon,
    DocumentAddIcon,
    DocumentDownloadIcon,
    UploadIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import FixtureHeader from "@/Components/FixtureHeader";
import {Popover, PopoverButton, PopoverGroup} from "@headlessui/vue";
import QuoteTabs from "@/Components/QuoteTabs";
import CreateFolder from "@/Components/SlideOuts/CreateFolder";
import CreateQuote from "@/Components/SlideOuts/CreateQuote";
import CreateService from "@/Components/SlideOuts/CreateService";
import Button from "@/Components/Button";
import pickBy from "lodash/pickBy";
import { router } from '@inertiajs/vue3'
import NestedDraggable from "@/Components/NestedDraggable";
import {emitter} from "@/eventHub";
import ImportAmazeQuote from "@/Components/SlideOuts/ImportAmazeQuote";
import AlertInfo from "@/Components/AlertInfo.vue";
import Audit from "@/Components/Modal/Audit.vue";

export default {
    layout: Authenticated,
    components: {
        ImportAmazeQuote,
        Audit,
        Button,
        QuoteTabs,
        FixtureHeader,
        ValidationErrors,
        Link,
        Head,
        PlusSmIcon,
        UsersIcon,
        InformationCircleIcon,
        Popover,
        PopoverButton,
        ChevronDownIcon,
        PopoverGroup,
        CogIcon,
        PencilIcon,
        ClipboardCopyIcon,
        CheckCircleIcon,
        ArrowCircleLeftIcon,
        FolderAddIcon,
        CreateFolder,
        FolderIcon,
        NestedDraggable,
        DocumentAddIcon,
        DocumentDownloadIcon,
        CreateQuote,
        CreateService,
        UploadIcon,
        AlertInfo
    },
    props: {
        fixture: Object,
        quote: Object,
        errors: Object,
        items: Object,
        bill_back_anomaly: Boolean,
        original: Boolean,
        invoice_quote_service_ids_not_paid: Array,
        invoice_quote_service_ids_paid: Array,
        subtotals: Object,
        activity_logs: Array
    },
    data() {
        return {
            showErrors: false,
            emitter: emitter,
            openModal: false
        }
    },
    mounted() {
        emitter.on('deleteFolder', (folder_id) => {
            this.deleteFolder(folder_id);
        });

        emitter.on('deleteService', (service_id) => {
            this.deleteService(service_id);
        });

        emitter.on('duplicateService', (service_id) => {
            this.duplicateService(service_id);
        });

        emitter.on("processItemMove", (oldIndex, newIndex, element) => {
            this.processItemMove(oldIndex, newIndex, element);
        });
    },
    methods: {
        number_format(nStr) {
            nStr += '';
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        doRounding(value, decimals) {
            return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(2);
        },
        editQuote(quote) {
            console.log(quote);
            this.$refs.create_quote.updating = true;
            this.$refs.create_quote.form.id = quote.id;
            this.$refs.create_quote.form.name = quote.name;
            this.$refs.create_quote.form.client = quote.client.name;
            this.$refs.create_quote.form.client_id = quote.client_id;
            this.$refs.create_quote.form.status = quote.status;
            this.$refs.create_quote.form.fixture_id = quote.fixture_id;
            this.$refs.create_quote.form.exchange_rate = quote.exchange_rate;
            this.$refs.create_quote.form.buy_currency_id = quote.buy_currency_id ?? "";
            this.$refs.create_quote.form.sell_currency_id = quote.sell_currency_id ?? "";
            this.$refs.create_quote.open();
        },
        processItemMove(event) {

            // ID of the moved item.
            var item_id = event.item.dataset.id;
            var item_type = event.item.dataset.type;

            // ID of the new parent ul folder.
            var parent_id = event.to.parentElement.dataset.id
            var parent_type = event.to.parentElement.dataset.type;

            // Get the list the item has been moved to.
            let list = [];

            for (let i = 0; i < event.to.children.length + 1; i++) {
                if (typeof event.to.children[i] !== "undefined") {
                    list.push({
                        type: event.to.children[i].dataset.type,
                        id: event.to.children[i].dataset.id,
                        order: i
                    });
                }
            }

            // Post request.
            this.$inertia.post(route('frontend.fixture.quote.move', [this.fixture.id, this.quote.id]), {
                item_id: item_id,
                item_type: item_type,
                parent_id: parent_id,
                parent_type: parent_type,
                list: list
            }, {
                preserveScroll: true,
                preserveState: true
            });
        },
        deleteFolder(folder_id) {
            this.$swal.fire({
                title: 'Remove Folder',
                html: "Are you sure you wish to delete this folder and any service lines contained within it? <br/><br/> Once removed you will not be able to restore this folder. <br/>",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$inertia.delete(route('frontend.fixture.quote.folder.delete', [this.fixture.id, this.quote.id, folder_id]), {
                            preserveScroll: true,
                            onSuccess: (page) => {

                            },
                            onError: (page) => {
                                this.loading = false
                                this.showErrors = true
                            }
                        });
                    }
                });
        },
        deleteService(service_id) {
            this.$swal.fire({
                title: 'Remove Service',
                html: "You are about to delete this service line from the quote, once removed you will be unable to restore this service line.<br/><br/>" +
                    "Are you sure you wish to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$inertia.delete(route('frontend.fixture.quote.service.delete', [this.fixture.id, this.quote.id, service_id]), {
                            preserveScroll: true,
                            onSuccess: (page) => {

                            },
                            onError: (page) => {
                                this.loading = false
                                this.showErrors = true
                            }
                        });
                    }
                });
        },
        duplicateService(service_id) {
            this.$swal.fire({
                title: 'Duplicate Service',
                html: "You are about to duplicate this service line.<br/><br/>" +
                    "Are you sure you wish to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
            .then((result) => {
                if (result.isConfirmed) {

                    axios.post(route('frontend.fixture.quote.service.duplicate', [this.fixture.id, this.quote.id, service_id])).then(response => {
                        if (response.data.message) {
                            // Reload the page
                            this.editService(response.data.new_service);
                        } else if (response.data.error) {
                            console.log('Unsuccessfully duplicated.')
                            this.loading = false
                            this.showErrors = true
                        }
                    });
                }
            });
        },
        confirmQuote(id) {
            this.$swal.fire({
                title: 'Confirm Quote',
                html: "By marking this quote as confirmed you are confirming that the quote has been accepted by the client. Changes can still be made to the quote but a copy of the original will also be created for tracking purposes this original quote can no longer be edited.<br/><br/>" +
                    "Are you sure you wish to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                stopKeydownPropagation: true,
                keydownListenerCapture: true
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.post(route('frontend.fixture.quote.confirm', [this.fixture.id, this.quote.id]), {
                        preserveScroll: true,
                        preserveState: false,
                        onError: (page) => {
                            this.loading = false
                            this.showErrors = true
                        }
                    });
                }
            });
        },
        editService(service) {
            emitter.emit("openServiceSlideout", service);
        },
    }
}
</script>
